import React from 'react';
import { shape, string } from 'prop-types';
import Button from '../../../components/Button';

const ContinueButtonPanel = ({ decodedToken }) => (
  <Button
    title="Continue to My Account"
    id="continueButton"
    name="continueButton"
    value="Continue to My Account"
    onClick={() => { window.location.href = decodedToken.retURL; }}
    style={{
      marginTop: '6px',
      width: '100%',
    }}
    primary
    className="cdlBtn"
  />
);

ContinueButtonPanel.propTypes = {
  decodedToken: shape({
    retURL: string.isRequired,
  }).isRequired,
};

export default ContinueButtonPanel;
